import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect, NavLink, withRouter, Link } from 'react-router-dom';
let user = localStorage.getItem('HippoUserInfo') ? JSON.parse(localStorage.getItem('HippoUserInfo')) : null;

class PrivateRoute extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { component: Component, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props => {
                    return  (
                        <Component {...props} />
                    )
                }}
            />
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./pages/login/PrivateRouteNoLogin.js